import {
  UnorderedList,
  type UnorderedListProps,
} from '@frontend/legacy-components';

export type ResponseUnorderedListProps = UnorderedListProps;

/**
 * Base unordered list component for Response.
 * Provides consistent styling for unordered lists in AI responses.
 */
export const ResponseUnorderedList = ({
  className,
  children,
  ...props
}: ResponseUnorderedListProps) => {
  return (
    <UnorderedList
      marginLeft={4}
      className={className}
      fontFamily="default"
      fontSize="md"
      lineHeight="md"
      pb={0.5}
      {...props}
    >
      {children}
    </UnorderedList>
  );
};
